import Grid from '@mui/material/Grid';
import * as React from 'react';

export interface IconBoxProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  withoutMargin?: boolean;
}

export function IconBox({ children, icon, withoutMargin }: IconBoxProps) {
  return (
    <Grid container spacing={1} wrap="nowrap" sx={!withoutMargin ? { alignItems: 'center' } : undefined}>
      <Grid size="auto" sx={!withoutMargin ? { mt: 1 } : undefined}>
        {icon}
      </Grid>
      <Grid size="auto" sx={{ textAlign: 'left' }}>
        {children}
      </Grid>
    </Grid>
  );
}
